"use client";

import React from "react";
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "@/shadcn-components/ui/resizable";
import { useTerminalStore } from "@/lib/terminal/store";
import TerminalOutput from "./TerminalOutput";
import TerminalInput from "./TerminalInput";
import TerminalContextMenu from "./TerminalContextMenu";
import DslExplorerPanel from "./DslExplorerPanel";

export default function TerminalDesktopContent() {
  const explorerDocked = useTerminalStore((s) => s.explorerDocked);
  const setExplorerDocked = useTerminalStore((s) => s.setExplorerDocked);

  const terminal = (
    <TerminalContextMenu>
      <div className="flex h-full w-full flex-col bg-background">
        <TerminalOutput />
        <TerminalInput />
      </div>
    </TerminalContextMenu>
  );

  if (!explorerDocked) {
    return terminal;
  }

  return (
    <ResizablePanelGroup
      direction="horizontal"
      autoSaveId="terminal-dsl-explorer"
      className="h-full w-full"
    >
      <ResizablePanel
        defaultSize={55}
        minSize={30}
        className="flex min-h-0 min-w-0 flex-col"
      >
        {terminal}
      </ResizablePanel>
      <ResizableHandle withHandle className="w-3 shrink-0 bg-border px-px" />
      <ResizablePanel
        defaultSize={45}
        minSize={25}
        className="flex min-h-0 min-w-0 flex-col bg-background"
      >
        <DslExplorerPanel
          variant="docked"
          onRequestClose={() => setExplorerDocked(false)}
        />
      </ResizablePanel>
    </ResizablePanelGroup>
  );
}
